/**
 * Rows shown per page before the user picks otherwise.
 *
 * Shared so the seven paginated pages cannot drift apart: each used to hardcode
 * its own `useState(50)`.
 */
export const DEFAULT_PAGE_SIZE = 25;

/** The choices offered by every "Éléments par page" selector. */
export const PAGE_SIZE_OPTIONS = [25, 50, 100, 200];
